import { useDeviceInfo } from '@b-stock/fe-core/bstock-next/components'
import { Breakpoint, DeviceType } from '@b-stock/fe-core/bstock-react'

export const useIsNarrow = () => {
  const { breakpoint } = useDeviceInfo()
  return breakpoint === Breakpoint.SMALL
}

export const useIsMobile = () => {
  const { deviceType, breakpoint } = useDeviceInfo()
  return deviceType !== DeviceType.DESKTOP || breakpoint < Breakpoint.LARGE
}
